<template>
  <div>
    <v-alert color="var(--blue-100)" class="mt-7 mb-0">
      <div class="d-flex flex-no-wrap">
        <div class="mr-3">
          <v-icon color="var(--blue-500)">mdi-information</v-icon>
        </div>
        <div>
          <span class="font-weight-bold">Important!</span> Before you provide
          payment details, please confirm that you are happy to proceed. You
          have only received limited information about Paymentshield, our
          services and policies. Full details, including terms and conditions,
          benefits, limitations and exclusions will be sent to you via your
          chosen preference in the next couple of days.
        </div>
      </div>
    </v-alert>

    <template v-for="(item, index) in question.Questions">
      <component
        v-if="item.IsVisible"
        :key="index"
        :is="item.AnswerControlType"
        :question="item"
        class="mb-n3"
      ></component>
    </template>
  </div>
</template>

<script>
import CheckboxBase from "@/components/Checkboxes/CheckboxBase";

export default {
  name: "LayoutApplicationLimitedInformationStatement",
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  components: {
    CheckboxBase,
  },
};
</script>

<style lang="scss" scoped></style>
